import { useQuery } from '@tanstack/react-query';

import ContentfulRichText from '@flipster/features/src/shared/contentful-rich-text';
import { useSupportedLocale } from '@flipster/i18n/hooks';
import { useOverlayItem } from '@flipster/overlay';
import { Spinner } from '@flipster/react/design-system';
import { Modal } from '@flipster/react/design-system-legacy/modal';
import { css } from '@flipster/styled-system/css';
import { center } from '@flipster/styled-system/patterns';

import { getPolicyBySlugApi } from '../../policies/[page]/api';

interface PrivacyInformationModalProps {
  type: string;
}

const PolicyInformationModal = ({ type }: PrivacyInformationModalProps) => {
  const locale = useSupportedLocale();
  const { onClose } = useOverlayItem();
  const { data } = useQuery({
    queryKey: ['policy', type, locale],
    queryFn: () => getPolicyBySlugApi(type, locale),
  });
  return (
    <Modal size='large'>
      <Modal.Close onClose={onClose} />
      <Modal.Header>
        <Modal.Title label={data?.title} />
      </Modal.Header>
      <Modal.Content>
        {data ? (
          <div className={css({ overflowY: 'auto', h: '100%', px: 2 })}>
            <ContentfulRichText richTextDocument={data.content} startHeadingLevel={3} />
          </div>
        ) : (
          <div className={center({ w: '100%', h: '100%' })}>
            <Spinner />
          </div>
        )}
      </Modal.Content>
    </Modal>
  );
};

export default PolicyInformationModal;
